<app-retailer-list
  [url]="API.RETAILER.VERIFICATION_LIST.GET_LIST_ACTIVE"
  [tableColumns]="tableColumns"
  [dataList]="dataList"
  (totalCount)="onTotalCount($event)"
></app-retailer-list>
